import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";
import Cookies from "js-cookie";
import { baseUrl } from "../AppConfig";

export const nursingHome = createApi({
    reducerPath: "nursingApi",
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            const token = Cookies.get("LOGIN_TOK");
            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAllNursingHomes: builder.mutation({
            query: (args) => {
                const { sort, page, search, sortkey, searchKey } = args;
                return {
                    url: "/api/v1/admin/nursing-home",
                    params: { sort: sort === "asc" ? 1 : -1, page, search, searchKey, sortkey: "createdAt" },
                };
            },
            invalidatesTags: ["nursingHome"],
        }),
        getNursingHome: builder.query({
            query: (params) => {
                return {
                    url: "/api/v1/admin/nursing-home",
                    params: { ...params },
                };
            },
        }),
        addNursingHome: builder.mutation({
            query: (body) => {
                return {
                    url: "/api/v1/admin/nursing-home",
                    method: "POST",
                    body,
                };
            },
            invalidatesTags: ["nursingHome"],
        }),
        editNursingHome: builder.mutation({
            query: (body) => {
                const { id } = body;
                return {
                    url: `/api/v1/admin/nursing-home/${id}`,
                    method: "PATCH",
                    body,
                };
            },
            invalidatesTags: ["nursingHome"],
        }),
        getNursingHomeById: builder.query({
            query: (id) => `/api/v1/admin/nursing-home/${id}`,
            providesTags: ["nursingHome"],
        }),
        deleteNursingHome: builder.mutation({
            query: (id) => {
                return {
                    url: `/api/v1/admin/nursing-home/${id}`,
                    method: "DELETE",
                };
            },
            invalidatesTags: ["nursingHome"],
        }),
    }),
});

export const {
    useGetAllNursingHomesMutation,
    useAddNursingHomeMutation,
    useDeleteNursingHomeMutation,
    useGetNursingHomeByIdQuery,
    useEditNursingHomeMutation,
    useGetNursingHomeQuery,
} = nursingHome;
